import type { CardProps } from "@karrtopelka/cards/types";
import {
  STOP_PERFECT_PROVOCATION,
  stopProvocation,
} from "@karrtopelka/cards/provocations";
import type { SubmitResult } from "@karrtopelka/game-kit";

/**
 * Build the result-card props for a finished stop run. display is the miss distance
 * ("3ms" — the template adds the "off the 5.00s stop" label under it). A frame-perfect
 * 0ms gets its own provocation; everything else picks deterministically on the delta.
 */
export function buildStopCard(
  deltaMs: number,
  handle: string,
  submit: SubmitResult | null,
): CardProps {
  const props: CardProps = {
    game: "stop",
    display: `${deltaMs}ms`,
    handle,
    provocation: deltaMs === 0 ? STOP_PERFECT_PROVOCATION : stopProvocation(deltaMs),
    date: new Date().toISOString().slice(0, 10),
  };
  // Rank line only once the board has volume (same threshold as the other games).
  if (submit && submit.total >= 10) {
    props.rankLine = `top ${submit.percentile}% today`;
  }
  return props;
}
